import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { OfficeAttendanceService } from 'src/app/services/office-attendance/office-attendance.service';
import * as moment from 'moment';

@Component({
  selector: 'app-export-office-attendance',
  templateUrl: './export-office-attendance.component.html',
  styleUrls: ['./export-office-attendance.component.scss']
})
export class ExportOfficeAttendanceComponent implements OnInit {
  generateButtonText: string = 'Generate Report';
  generateDisabled: boolean = false;
  availableYears: number[] = [];
  availableMonths: string[] = [];
  availableBaseLocation: string[] = [];
  selectedMonth: number = new Date().getMonth() + 1;
  selectedYear: number = new Date().getFullYear();
  selectedBaseLocation: string = 'Pune';
  availableWeeks: string[] = [];
  selectedWeek: string;
  selectedDate!: Date;
  weekStart!: Date;
  weekEnd!: Date;
  weekDisplay = '';
  highlightedDates: string[] = [];

  constructor(public dialogRef: MatDialogRef<ExportOfficeAttendanceComponent>,
    private officeAttendanceService: OfficeAttendanceService,
    private toasterService: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.highlightedDates = data.highlightedDates;
  }

  ngOnInit(): void {
    this.setPreviousWeekDate();
    this.availableYears = this.getAvailableYears();
    this.availableMonths = this.getAvailableMonths();
    this.availableBaseLocation = this.getAvailableBaseLocation();
    
  }

  setDate() {
    const today = new Date();
    this.selectedDate = new Date(today);
    this.onDateSelected(this.selectedDate);
  }

  setPreviousWeekDate() {
    const today = new Date();
    today.setDate(today.getDate() - 7); // ⬅️ go back one week
    this.selectedDate = new Date(today);
    this.onDateSelected(this.selectedDate);
  }


  generateReport() {
    if (!this.selectedWeek) {
      this.toasterService.error('Please select a week');
      return;
    }

    this.generateButtonText = 'Please wait..';
    this.generateDisabled = true;

    this.officeAttendanceService
      .getWeeklyAttendanceReport(
        this.selectedWeek,
        this.selectedBaseLocation
      )
      .subscribe(
        (response: any) => {
          const start = this.formatDateDDMMYYYY(this.weekStart);
          const end = this.formatDateDDMMYYYY(this.weekEnd);

          const filename =
            `${this.selectedBaseLocation}_${start}_to_${end}_Attendance_Report.xlsx`;

          const blob = new Blob(
            [response.body],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);

          this.generateButtonText = 'Download Report';
          this.generateDisabled = false;
        },
        () => {
          this.toasterService.error('Error downloading the file');
          this.generateDisabled = false;
        }
      );
  }

  private formatDateDDMMYYYY(date: Date): string {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}-${m}-${y}`;
  }

  getAvailableYears(): number[] {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= 2025; year--) {
      years.push(year);
    }
    return years;
  }

  getAvailableMonths(): string[] {
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames;
  }
  getAvailableBaseLocation(): string[] {
    const baseLocation = [
      'Pune', 'Bangalore'
    ];
    return baseLocation;
  }


  matDialogClose() {
    this.dialogRef.close();
  }

  onDateSelected(date: Date) {
    if (!date) return;

    const localDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      12 // noon avoids UTC rollback
    );

    // Monday = 0, Sunday = 6
    const day = (localDate.getDay() + 6) % 7;

    this.weekStart = new Date(localDate);
    this.weekStart.setDate(localDate.getDate() - day);
    this.weekStart.setHours(0, 0, 0, 0);

    this.weekEnd = new Date(this.weekStart);
    this.weekEnd.setDate(this.weekStart.getDate() + 6);
    this.weekEnd.setHours(23, 59, 59, 999);

    // Java LocalDate compatible strings
    const start = this.toLocalDate(this.weekStart);
    const end = this.toLocalDate(this.weekEnd);
    this.selectedWeek = `${start} - ${end}`;
    this.weekDisplay = this.formatWeek(this.weekStart, this.weekEnd);
  }


  toLocalDate(date: Date): string {
  return date.toISOString().split('T')[0]; // yyyy-MM-dd
}



  formatWeek(start: Date, end: Date): string {
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };

    return `${start.toLocaleDateString('en-GB', options)} - ${end.toLocaleDateString('en-GB', options)}`;
  }

  highlightedDateClass = (date: Date): string => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    return this.highlightedDates.includes(formattedDate) ? 'highlighted-date' : '';
  };

  dateClasses = (date: Date): string => {
    const classes: string[] = [];

    // Always apply highlighted-date if applicable
    const highlighted = this.highlightedDateClass(date);
    if (highlighted) {
      classes.push(highlighted);
    }

    // Apply week highlight only if week is selected
    if (this.weekStart && this.weekEnd) {
      const d = date.getTime();
      if (
        d >= this.weekStart.getTime() &&
        d <= this.weekEnd.getTime()
      ) {
        classes.push('week-highlight');
      }
    }

    return classes.join(' ');
  };

}